import React, { useEffect } from "react";
import { Modal, Form, Input, Button } from "antd";
import { translations } from "../../utils/Translation/staticTranslation";
import "./Contacts.css";

const CreateContactListModal = ({
  visible,
  onClose,
  onSubmit,
  editData,
  loading = false,
}) => {
  const lang = localStorage.getItem("language") || "ar";
  const t = translations[lang]?.contactsPage || {};
  const [form] = Form.useForm();

  useEffect(() => {
    if (visible) {
      if (editData) {
        form.setFieldsValue({
          name: editData.name,
          description: editData.description,
        });
      } else {
        form.resetFields();
      }
    }
  }, [visible, editData, form]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      onSubmit(values);
    } catch (error) {
      console.error("Validation failed:", error);
    }
  };

  return (
    <Modal
      open={visible}
      title={
        editData
          ? t?.edit_contact_list || "Edit Contact List"
          : t?.create_contact_list || "Create Contact List"
      }
      onCancel={() => {
        if (!loading) {
          onClose();
        }
      }}
      closable={!loading}
      footer={null}
      width={600}
      centered
      className="create-contact-list-modal"
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        autoComplete="off"
      >
        <Form.Item
          name="name"
          label={t?.form?.name || "Name"}
          rules={[
            {
              required: true,
              message: t?.form?.name_required || "Name is required",
            },
          ]}
        >
          <Input
            placeholder={t?.form?.name_placeholder || "Enter contact group name"}
          />
        </Form.Item>

        <Form.Item
          name="description"
          label={t?.form?.description || "Description"}
        >
          <Input.TextArea
            rows={4}
            placeholder={
              t?.form?.description_placeholder || "Enter description"
            }
          />
        </Form.Item>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "12px",
            marginTop: "24px",
          }}
        >
          <Button
            onClick={onClose}
            disabled={loading}
            className="create-contact-modal-button"
            style={{
              minWidth: "120px",
              height: "46px",
              borderRadius: "50px",
              border: "1px solid #D0D5DD",
              backgroundColor: "#FFFFFF",
              color: "#344054",
            }}
          >
            {t?.modal?.cancel || "Cancel"}
          </Button>
          <Button
            type="primary"
            onClick={handleSubmit}
            loading={loading}
            className="create-contact-modal-button-primary"
            style={{
              minWidth: "120px",
              height: "46px",
              borderRadius: "50px",
            }}
          >
            {editData
              ? t?.modal?.update || "Update"
              : t?.modal?.create || "Create"}
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default CreateContactListModal;
